export default {
  meta: {
    title: '点位详情'
  }
};
